import type { I18nFn } from 'i18n/types/I18nFn';
import { getCountryName } from 'utils/internationalization';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getCityStateString(i18n: I18nFn, address: Record<string, any>) {
  return [
    address.city,
    address.stateCode,
    address.country === 'US' ? null : getCountryName(i18n, address.country),
  ]
    .filter((part) => part)
    .join(', ');
}
